<template>
    <div>
        <!-- 头部 -->
        <div class="header">
            <div class="header-left">
                <img @click="$router.push({ path: '/' })" src="@/assets/img/logo@2x.png" class="logo" alt="">
            </div>
            <div class="nav">
                <div @click="$router.push({ path: '/' })" class="nav-item">
                    首页
                </div>
                <div class="nav-item">
                    关于我们
                </div>
                <div @click="$router.push({ path: '/webC' })" class="nav-item">
                    项目介绍
                </div>
                <div @click="$router.push({ path: '/contact' })" class="nav-item">
                    联系我们
                </div>
            </div>
        </div>

        <div class="bgImg">
            <div class="title">
                <div>关于我们</div>
                <div>ABOUT US</div>
            </div>
        </div>
        <div class="content">
            <div class="color1">关于我们</div>
            <div class="color2">ABOUT US</div>
            <div class="color3"></div>
            <img src="../../assets/img/aboutUs/contentImg.png" class="contentImg" />
            <div class="txt">
                <p>
                    四川联裕科技信息有限公司成立于2018年，位于四川遂宁，我们专注于智能交通领域，以车联网、云计算、大数据处理、无线通信和北斗/GPS全球定位技术为核心，针对巡游/网约出租车、物流/两客一危、前装新能源、驾驶培训、汽车租赁、试乘试驾等行业提供符合客户需求的产品和解决方案，为客户创造价值。
                </p>
                <p>
                    四川联裕科技信息有限公司成立于2018年，是一家集平台研发、设计、销售于一体的四川本土企业，致力于为用户提供全方位流媒体监控及巡游/网约出租车系统开发运维的解决方案。
                </p>
            </div>
        </div>

        <div class="footer">
            <div class="company">四川联裕科技信息有限公司</div>
            <div class="beian" @click="openUrl('https://beian.miit.gov.cn/#/Integrated/index')">
                蜀ICP备2024044808号-4-4
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {
    },
    props: {},
    data() {
        return {};
    },
    computed: {},
    watch: {},
    created() { },
    mounted() { },
    methods: {
        openUrl(url) {
            window.open(url);
        }
    },
};
</script>
<style scoped lang="less">
.header {
    width: 100%;
    height: 153px;
    background-color: rgba(12, 21, 27, .6);
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    top: 0;
    left: 0;

    .header-left {

        .logo {
            cursor: pointer;
            width: 231px;
            height: 101px;
            margin-left: 136px;
        }
    }

    .nav {
        display: flex;
        margin-right: 121px;
        width: 594px;
        justify-content: space-between;

        .nav-item {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 21px;
            color: #FFFFFF;
            line-height: 29px;
            cursor: pointer;
        }
    }

    .banner-img {
        width: 100%;
        height: 828px;
    }
}

.bgImg {
    margin-top: 153px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 650px;
    background: url('../../assets/img/aboutUs/banner.png') no-repeat;
    background-size: 100% 100%;

    .title {
        font-family: 'SourceHanSansCN-Bold';
        background-color: rgba(40, 40, 40, .34);
        padding-top: 62px;
        padding-bottom: 64px;
        padding-left: 155px;
        padding-right: 150px;
        text-align: center;
        color: #fff;

        div:nth-child(1) {
            font-size: 78px;
            font-weight: bold;
            line-height: 73px;
        }

        div:nth-child(2) {
            margin-top: 22px;
            font-size: 24px;
            font-weight: bold;
            line-height: 18px;
        }
    }
}

.content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 123px;

    .color1 {
        font-family: 'MicrosoftYaHei';
        font-weight: 400;
        font-size: 33px;
        color: #0069AA;
        line-height: 33px;
    }

    .color2 {
        margin-top: 24px;
        font-family: 'AdobeFanHeitiStd-Bold-Alphabetic';
        font-size: 58px;
        color: #222222;
        line-height: 47px;
    }

    .color3 {
        margin-top: 27px;
        width: 53px;
        height: 2px;
        background-color: rgba(0, 0, 0, .5);
    }

    .contentImg {
        margin-top: 99px;
        width: 1495px;
        height: 580px;
        object-fit: cover;
    }

    .txt {
        width: 1066px;
        margin-top: 91px;
        margin-bottom: 255px;
        width: 1066px;
        font-size: 33px;
        color: #282828;
        line-height: 75px;

        p {
            text-indent: 2em;
        }
    }
}

.footer {
    padding-top: 50px;
    padding-bottom: 51px;
    width: 100%;
    background-color: rgba(39, 39, 39, 1);
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 21px;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}
</style>